export const defaultStyle = {
  bodyStyle: {
    backgroundColor: "#FFF000",
    color: "#22486d",
    fontType: "arial",
  },
  modalStyle: {
    backgroundColor: "white",
    color: "#22486d",
  },
  submitButtonStyle: {
    backgroundColor: "#00a2ee",
    borderColor: "#00a2ee",
    color: "#FFF",
  },
  backButtonStyle: {
    backgroundColor: "#FFF",
    borderColor: "#22486d",
    color: "#22486d",
  },
  phoneIconName: "fas fa-phone",
  emailIconName: "fas fa-envelope",
  iconStyle: {
    color: "#22486d",
    hoverColor: "#38a2ee",
    borderColor: "#d8d8d8",
    backgroundColor: "",
  },
  successPageStyle: {
    message: [
      {
        en: "Thank you for your feedback!",
        it: "Grazie per il tuo feedback!",
      },
      {
        en: "You will be contacted by our team as soon as possible.",
        it: "Verrai contattato dal nostro team il prima possibile.",
      },
    ],
    messageColor: "#22486d",
    icon: "fas fa-check-double", // or null
    iconColor: "#22486d", // or null
  },
  errorMessage: {
    en: "We are sorry, there has been a problem with processing your data!",
    it:
      "Siamo spiacenti, si è verificato un problema con l'elaborazione dei dati!",
  },
};
